/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@eureca/candidate-api-sdk/client';
import type { Client, RequestConfig, ResponseErrorConfig } from '@eureca/candidate-api-sdk/client';
import type {
  PostMyIdentityConfirmationMutationRequest,
  PostMyIdentityConfirmationMutationResponse,
  PostMyIdentityConfirmation401,
  PostMyIdentityConfirmation403,
  PostMyIdentityConfirmation409,
  PostMyIdentityConfirmation422,
  PostMyIdentityConfirmation429,
  PostMyIdentityConfirmation502,
  PostMyIdentityConfirmation503,
} from '../types/PostMyIdentityConfirmation.ts';

function getPostMyIdentityConfirmationUrl() {
  const res = { method: 'POST', url: `/me/identity-confirmation` as const };
  return res;
}

/**
 * {@link /me/identity-confirmation}
 */
export async function postMyIdentityConfirmation(
  data: PostMyIdentityConfirmationMutationRequest,
  config: Partial<RequestConfig<PostMyIdentityConfirmationMutationRequest>> & {
    client?: Client;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostMyIdentityConfirmationMutationResponse,
    ResponseErrorConfig<
      | PostMyIdentityConfirmation401
      | PostMyIdentityConfirmation403
      | PostMyIdentityConfirmation409
      | PostMyIdentityConfirmation422
      | PostMyIdentityConfirmation429
      | PostMyIdentityConfirmation502
      | PostMyIdentityConfirmation503
    >,
    PostMyIdentityConfirmationMutationRequest
  >({
    method: 'POST',
    url: getPostMyIdentityConfirmationUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
